import type { FormikContextType } from 'formik';
import { useFormik } from 'formik';
import _ from 'lodash';
import { useEffect } from 'react';
import * as Yup from 'yup';
import { Alert, Store } from '../../store';

interface Values {
  name: string;
  password: string;
  passwordConfirm: string;
}

interface Form {
  formik: FormikContextType<Values>;
  loading: boolean;
  alert: Alert;
}

const validationSchema = Yup.object({
  name: Yup.string().trim().required('Please enter a name.'),
  password: Yup.string().trim().required('A valid password is required.'),
  passwordConfirm: Yup.string().oneOf([Yup.ref('password'), undefined], 'Passwords must match')
});

export const useForm = (): Form => {
  const [confirmUser, { loading, error, token, webplayerToken }] = Store.User.useConfirmUser();
  const alert = Alert.useAlert(error);

  const formik = useFormik<Values>({
    initialValues: { name: '', password: '', passwordConfirm: '' },

    validationSchema,
    validateOnMount: true,

    validate(): void {
      alert.hide();
    },

    onSubmit(data: Values): void {
      alert.hide();

      if (!loading) {
        // Execute the mutation
        confirmUser(_.omit(data, 'passwordConfirm'));
      }
    }
  });

  useEffect(() => {
    if (token && webplayerToken) {
      // Houston, we have received authorization to proceed
      Store.User.login({ token, webplayerToken });
    }
  }, [token, webplayerToken]);

  return {
    formik,
    loading,
    alert
  };
};
